import React, { useState, useEffect } from 'react';
import { Button } from 'antd'
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import NewsSwiper from '../news-swiper';
import { apiConfig, apiGetPage } from '../../request/api'
import { imageUrl, zeusApp } from '../../request/index'; 
import { useCustomData } from '../../pages/context/newsCustomDataProvider';

interface NewsPart1Props {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface PageData {
    id: string;
    newstitle: string;
    onlineTime: string;
    newsContent: string;
    newsImage: string;
    state: string | null;
}

const NewsPart1: React.FC<NewsPart1Props> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [partList, setPartList] = useState<PageData[]>([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const pageSize = 5;
        const { getValue } = useCustomData();
        const notHaveMore = getValue('notHaveMore');
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    useEffect(() => {
        loadData(1);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (!hasMore) return;

            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const fullHeight = document.body.scrollHeight;

            if (scrollTop + windowHeight + 100 >= fullHeight) {
                const nextPage = page + 1;
                loadData(nextPage);
                setPage(nextPage);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [page, hasMore]);

    const loadData = (currentPage: number) => {
        apiGetPage({
            tid: '3E0B92D9B5834E49B146D40BAE5814DF',
            page: currentPage,
            size: pageSize,
            sort: 'seq',
            search: '',
            languagecode:languageCode
        })
            .then(res => {
                const newRows = res.data.data.rows;
                if (newRows.length < pageSize) {
                    setHasMore(false); // 已加载全部
                }
                setPartList(prev => [...prev, ...newRows]);
            })
            .catch(err => {
                console.log('加载失败', err);
            });
    };

    const goNewsItem = (id: string) => {
        console.log(id)
        handleViewChange('newsdetails', id)
    }

    return (
        <div className="news-part1">
            <NewsSwiper />
            <div className='news-content'>
                {partList.map((item, index) => (
                    <div className='news-item' key={item.id} onClick={() => goNewsItem(item.id)}>
                        <div className="news-item-left">
                            <div className="news-item-title">{item.newstitle}</div>
                            <div className="news-item-time">{item.onlineTime}</div>
                        </div>
                        <div className="news-item-image" style={{ backgroundColor: themeColor }}>
                            <img
                                src={`${imageUrl}${item.newsImage}?zeus-app=${zeusApp}`}
                                alt="封面图"
                                onError={(e) => {
                                    (e.target as HTMLImageElement).src = '/default-news-image.png';
                                }}
                            />
                        </div>
                    </div>
                ))}
                {hasMore ? (
                    <div style={{ textAlign: 'center', margin: '16px' }}>loading...</div>
                ) : (
                    <div style={{ textAlign: 'center', margin: '16px', color: '#888888' }}>{notHaveMore}</div>
                )}
            </div>
        </div>
    );
};

export default NewsPart1;